import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppSettings} from "../../config/config";
import {map} from 'rxjs/operators';

@Injectable()
export class TransportService{

  private _url = AppSettings.API_ENDPOINT;
  constructor(private http: HttpClient){}


  getAllBusRoutes(schoolId,AUTHTOKEN){
    const params = {schoolId: schoolId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url+'/bus/getBusRouteList',
      params,{ headers: headers})
      .pipe(map(res => res));

  }
  getBusListForStop(stopId, academicId,AUTHTOKEN){
    let current_academic =  academicId;
    const params = {stopId:stopId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/getBusListFoStop',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  getAllBuses(schoolId,academicId,AUTHTOKEN){
    let current_academic = academicId;
    const params = {schoolId: schoolId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url+'/bus/getbuses',
      params,{ headers: headers})
      .pipe(map(res => res));
  }

  getstopsOfRoute(schoolId,routeId,academicId,AUTHTOKEN){
    let current_academic = academicId;
    const params = {schoolId: schoolId,routeId:routeId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url+'/bus/viewStopforRoute',
      params,{ headers: headers})
      .pipe(map(res => res));
  }


  fetchTransportCount(schoolId,AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {schoolId:schoolId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/getbuscount',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  fetchAllBuses(schoolId,AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {schoolId:schoolId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/getbuses',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  fetchActiveBuses(schoolId,AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {schoolId:schoolId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/activebuses',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  fetchInActiveBuses(schoolId,AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {schoolId:schoolId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/getinactivebuses',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  fetchBusesDetail(AUTHTOKEN,busId){
    let current_academic = localStorage.getItem('current_academic');
    const params = {pkBusId:busId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/getdriverinfo',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  fetchBusesRoute(AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/getBusRouteList',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  insertBusRoute(routename, startpoint, endpoint, totalstops, AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {RouteName:routename,StartPoint:startpoint,EndPoint:endpoint,TotalStops:totalstops,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/addBusrouteinfo',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  fetchBusStop(selectedAcademicId,AUTHTOKEN){
    let current_academic = selectedAcademicId;
    
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/getBusStopsList',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  fetchDriverList(AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/driverlist',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  addNewBus(bus,AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = bus;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/addbuses',
      params, {headers:headers})
      .pipe(map(res => res));
  }




  updateBus(bus,busId,AUTHTOKEN){
    bus.BusId = busId;
    bus.current_academic = localStorage.getItem('current_academic');
    const params = bus;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/update_busDetail',
      params, {headers:headers})
      .pipe(map(res => res));
  }

  addStopTerm(termObj,AUTHTOKEN){
    termObj.current_academic = localStorage.getItem('current_academic');
    const params = termObj;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/addtermforstops',
        params, {headers:headers})
        .pipe(map(res => res));
  }
  getStopTerms(AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/gettermsofstops',
        params, {headers:headers})
        .pipe(map(res => res));
  }

  deleteStopTerms(termId,AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {pkBusStopTermId:termId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/deletestopterm',
        params, {headers:headers})
        .pipe(map(res => res));
  }

  editStopTerms(termInfo,AUTHTOKEN){
    termInfo.current_academic = localStorage.getItem('current_academic');
    const params = termInfo;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/editstopterm',
        params, {headers:headers})
        .pipe(map(res => res));
  }

  getTermInfo(termId,AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {pkBusStopTermId:termId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/getterminfo',
        params, {headers:headers})
        .pipe(map(res => res));
  }

  getAvailableStopTerms(AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/getavailabletermsofstops',
        params, {headers:headers})
        .pipe(map(res => res));
  }

  getStudentTermsDetail(studentId,AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {studentId:studentId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/getbustermsforstudent',
        params, {headers:headers})
        .pipe(map(res => res));
  }

  getStopTermsOfStudent(studentId,AUTHTOKEN){
    const params = {studentId:studentId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/getbustermsofstudent',
        params, {headers:headers})
        .pipe(map(res => res));
  }
  fetchRouteDetail(AUTHTOKEN, routeId){
    let current_academic = localStorage.getItem('current_academic');
    const params = {routeId:routeId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/routeDetail',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  updateBusRoute(routename, startpoint, endpoint, totalstop, routeId, AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {RouteName:routename,StartPoint:startpoint,EndPoint:endpoint,TotalStop:totalstop,routeId:routeId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/updatebusroute',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  deleteRouteDetail(AUTHTOKEN, routeId){
    let current_academic = localStorage.getItem('current_academic');
    const params = {routeId:routeId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/deleteBusRoute',
      params, {headers:headers})
      .pipe(map(res => res));
  }

  addBusStop(stopsName, fare, latitude, longitude, AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {BusStopName:stopsName,fare:fare,current_academic:current_academic,latitude : latitude,longitude : longitude};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/createbusstop',
      params, {headers:headers})
      .pipe(map(res => res));
  }

  fetchStopDetail(AUTHTOKEN, stopId){
    let current_academic = localStorage.getItem('current_academic');
    const params = {stopId:stopId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/stopsDetail',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  updateBusStop(stopsName, fare, latitude, longitude, stopId, AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {BusStopName:stopsName,Busfare:fare,stopId:stopId,current_academic:current_academic,latitude :latitude,longitude :longitude};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/updateBusStops',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  deleteStopDetail(AUTHTOKEN,stopId){
    let current_academic = localStorage.getItem('current_academic');
    const params = {stopId:stopId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/deleteBusStops',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  fetchStopForRoute(AUTHTOKEN, routeId){
    let current_academic = localStorage.getItem('current_academic');
    const params = {routeId:routeId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/viewStopforRoute',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  assignStopForRoute(stoplist, pkRouteId, AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {stopIdList:stoplist,FkRouteId:pkRouteId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/addBusRouteStopsInfo',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  deleteBusDetail(AUTHTOKEN,pkBusId){
    let current_academic = localStorage.getItem('current_academic');
    const params = {pkBusId:pkBusId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/deleteBusDetail',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  fetchStudentDetailsForOptedBus(busId,schoolId,AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {pkBusId:busId,schoolId:schoolId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/fetchStudentDetailsForOptedBus',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  migrateTransportService(academic, AUTHTOKEN){
    const params = academic;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/bus/migrateTransport',
      params, {headers:headers})
      .pipe(map(res => res));
  }
  currentAndPreviousAcademicService(AUTHTOKEN){
    let current_academic = localStorage.getItem('current_academic');
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url+'/promote/currentAndPreviousAcademic',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
}
